import * as React from "react";
import {useEffect, useState} from "react";
import {Button, TextField} from "@mui/material";
import FormWrapper from "../PaperFormWrapper/PaperFormWrapper";
import {changePassword} from "../../utils/Api";
import {useSnackbar} from "notistack";


export default () => {
    const [loading, setLoading] = useState(false);
    const [isValid, setIsValid] = useState(false);

    const [password, setPassword] = useState('');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const {enqueueSnackbar} = useSnackbar();

    const toastHelper = (msg, type) => {
        enqueueSnackbar(msg, {
            preventDuplicate: true,
            variant: type,
            anchorOrigin: {horizontal: 'right', vertical: 'bottom'}
        });
    }

    useEffect(() => {
        isFormValid()
    }, [password, newPassword, confirmPassword]);

    const submitPasswordChange = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);

        try {
            await changePassword({
                "old_password": password,
                "new_password": newPassword
            });
            toastHelper("Password changed successfully!", "success");
        } catch (err) {
            console.error(err)
            const errorText = err.response.data[Object.keys(err.response.data)[0]];
            toastHelper("Error: " + errorText, "error");
        }

        setPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setLoading(false);
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    }

    const handleNewPasswordChange = (event) => {
        setNewPassword(event.target.value);
    }

    const handleConfirmPasswordChange = (event) => {
        setConfirmPassword(event.target.value);
    }

    const isFormValid = () => {
        setIsValid(password !== "" && newPassword !== "" && newPassword === confirmPassword);
    }

    return (
        <FormWrapper
            topPadding={0}
            title="Change Password"
            onSubmit={submitPasswordChange}
            loading={loading}
        >
            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                id="password"
                label="Current Password"
                name="password"
                type="password"
                value={password}
                disabled={loading}
                onChange={handlePasswordChange}
            />
            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                name="newPassword"
                label="New Password (8 characters min.)"
                type="password"
                id="newPassword"
                value={newPassword}
                disabled={loading}
                onChange={handleNewPasswordChange}
            />
            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                disabled={loading}
                onChange={handleConfirmPasswordChange}
            />
            <Button
                type="submit"
                variant="contained"
                sx={{mt: 3, float: 'right'}}
                disabled={loading || !isValid}
            >
                Save
            </Button>
        </FormWrapper>
    )
}